/**
 * Subscription offers are sold in some countries only (the list lives in
 * snippets/subs-allowed.liquid). Liquid already leaves them out when the
 * visitor browses a market outside that list, but most visitors never pick
 * a market: they browse the default (US) one from wherever they are.
 *
 * This asks Shopify's own detection endpoint for the visitor's country and,
 * when it is not allowed, hides every element marked data-subs-only, shows
 * what is marked data-subs-alt, and moves the purchase-option rows to One
 * time, so nothing subscription-related can be added to the cart from the
 * page. The checkout enforces the same rule on its own through the
 * subscriptions-only shipping profile; this only keeps the page from
 * offering what the checkout will refuse.
 *
 * When the detected country has a market of its own priced in USD (Colombia
 * today), the visitor is moved into that market once per session, so the flag
 * in the header matches where they are and the hiding is done by Liquid on
 * the next page. Countries whose market would change the currency are not
 * switched, so nobody sees prices change on their own.
 *
 * A country picked in the store's own country selector wins over detection:
 * someone in Colombia who is shipping to the United States picks United
 * States and sees the plans. The pick is remembered in localStorage because
 * Shopify sets its localization cookie on every visit, chosen or not, so the
 * cookie cannot tell a deliberate choice from the default.
 *
 * Reads its inputs from its own <script> tag (snippets/subs-geo.liquid).
 */
(function () {
  if (window.fmeSubsGeoLoaded) return;
  window.fmeSubsGeoLoaded = true;

  var tag = document.querySelector('script[data-subs-geo]');
  if (!tag) return;

  var allowed = (tag.getAttribute('data-allowed') || 'US')
    .toUpperCase()
    .split(',')
    .map(function (code) {
      return code.trim();
    })
    .filter(Boolean);
  var current = (tag.getAttribute('data-country') || 'US').toUpperCase();
  var endpoint = tag.getAttribute('data-endpoint') || '/browsing_context_suggestions.json';
  var switchable = (tag.getAttribute('data-switch') || '')
    .toUpperCase()
    .split(',')
    .map(function (code) {
      return code.trim();
    })
    .filter(Boolean);
  var localizationUrl = tag.getAttribute('data-localization') || '/localization';

  var KEY = 'fme:geo-country';
  var CHOICE = 'fme:geo-choice';
  var SWITCHED = 'fme:geo-switched';

  // Remember a pick in a country selector. There are three of them, and each
  // sends its form in its own way, so each is watched in its own way.
  // Registered before anything else so it works in every market.
  function remember(value) {
    var code = String(value || '').toUpperCase();
    if (!/^[A-Z]{2}$/.test(code)) return;
    try {
      localStorage.setItem(CHOICE, code);
    } catch (e) {
      /* without storage the pick still switches the market; detection runs again */
    }
  }

  // Dawn's selector: its localization form submits on click, which fires no
  // submit event, so the click is watched.
  document.addEventListener(
    'click',
    function (event) {
      var item = event.target && event.target.closest && event.target.closest('localization-form a[data-value]');
      if (!item) return;
      // The language picker is a localization-form too; only the country one counts.
      var picker = item.closest('localization-form');
      if (!picker || !picker.querySelector('input[name="country_code"]')) return;
      remember(item.getAttribute('data-value'));
    },
    true
  );

  // The header's panels (snippets/fme-chrome.liquid): every country is a
  // submit button named country_code. The language chips are not.
  document.addEventListener(
    'submit',
    function (event) {
      var button = event.submitter || document.activeElement;
      if (!button || button.name !== 'country_code' || button.form !== event.target) return;
      remember(button.value);
    },
    true
  );

  // The header's drawer: a select named country_code whose form is sent from
  // script as soon as it changes, which fires no submit event either.
  document.addEventListener(
    'change',
    function (event) {
      var field = event.target;
      if (!field || field.tagName !== 'SELECT' || field.name !== 'country_code') return;
      remember(field.value);
    },
    true
  );

  // Liquid already hid the offers for this market; nothing left to do.
  if (allowed.indexOf('*') === -1 && allowed.indexOf(current) === -1) return;

  /*
   * The rows can render with a subscription row checked (the default offer).
   * Once those rows are hidden the selection moves to One time; the change
   * event lets the other scripts follow (variant, price, INCLUDES note, the
   * app's hidden widget).
   */
  function forceOneTime() {
    var fieldset = document.querySelector('fieldset.po3');
    if (!fieldset) return;

    var checked = fieldset.querySelector('input[name="purchase_option"]:checked');
    if (checked && !checked.closest('[data-subs-only]')) return;

    var once = fieldset.querySelector('input[name="purchase_option"][value="single"]');
    if (!once) return;
    once.checked = true;

    // This can run before the row scripts have booted (the tag also sits
    // in the header), so the variant is written here as well; the price
    // script re-renders from whatever is in this input.
    var variant = once.getAttribute('data-variant');
    var idInput =
      document.querySelector('product-form form[action*="/cart/add"] input[name="id"]') ||
      document.querySelector('form[action*="/cart/add"]:not([id*="installment"]) input[name="id"]');
    if (variant && idInput && idInput.value !== variant) {
      idInput.value = variant;
      idInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    once.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function apply(country) {
    // '*' in the list: every country may subscribe, nothing is hidden.
    if (!country || allowed.indexOf('*') !== -1 || allowed.indexOf(country) !== -1) return;
    document.documentElement.classList.add('subs-hidden');
    forceOneTime();
    // Lets other scripts react (the announcement bar skips hidden slides).
    document.dispatchEvent(new CustomEvent('fme:subs-hidden'));
  }

  /*
   * Moves the visitor into their own country's market, the same request the
   * country selector makes. Once per session, and only for countries whose
   * market keeps the currency. Returns true when a reload is on its way.
   */
  function switchMarket(country) {
    if (!country || country === current || switchable.indexOf(country) === -1) return false;
    try {
      if (sessionStorage.getItem(SWITCHED)) return false;
      sessionStorage.setItem(SWITCHED, country);
    } catch (e) {
      return false; // without storage a failed switch could loop; stay put
    }
    var form = document.createElement('form');
    form.method = 'post';
    form.action = localizationUrl;
    var fields = {
      form_type: 'localization',
      utf8: '\u2713',
      _method: 'put',
      return_to: window.location.pathname + window.location.search,
      country_code: country,
    };
    Object.keys(fields).forEach(function (name) {
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = fields[name];
      form.appendChild(input);
    });
    document.body.appendChild(form);
    form.submit();
    return true;
  }

  // Detected (not chosen) country: hide right away, then let the market follow.
  function applyDetected(country) {
    apply(country);
    switchMarket(country);
  }

  // The visitor already said where they shop: respect it, skip detection.
  var choice = null;
  try {
    choice = localStorage.getItem(CHOICE);
  } catch (e) {
    /* fine, fall through to detection */
  }
  if (choice) {
    apply(choice);
    return;
  }

  var cached = null;
  try {
    cached = sessionStorage.getItem(KEY);
  } catch (e) {
    /* storage may be unavailable; detection simply runs again */
  }
  if (cached) {
    applyDetected(cached);
    return;
  }

  fetch(endpoint + '?country[enabled]=true', {
    credentials: 'same-origin',
    headers: { Accept: 'application/json' },
  })
    .then(function (response) {
      return response.ok ? response.json() : null;
    })
    .then(function (data) {
      var detected = data && data.detected_values && data.detected_values.country;
      var country = detected && detected.handle ? String(detected.handle).toUpperCase() : '';
      if (!country) return;
      try {
        sessionStorage.setItem(KEY, country);
      } catch (e) {
        /* fine without the cache */
      }
      applyDetected(country);
    })
    .catch(function () {
      /* Unknown country: leave the page as rendered; the checkout still enforces the rule. */
    });
})();
